var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.$root.isRouterAlive ? _c("router-view") : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.manualVisible,
            width: "80%",
            "show-close": false,
            "custom-class": "home-guide",
            "close-on-click-modal": false
          }
        },
        [_c("div", [_c("manual", { on: { handleClose: _vm.handleClose } })], 1)]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }